import { baseApi } from '@shared/utils/api/configs/rtkBaseQueryDemo';

import { getServiceCatalog, SERVICE_CATALOG_TAGS } from './endpoints';

const serviceCatalogApi = baseApi
  .injectEndpoints({
    endpoints: (builder) => ({
      getServiceCatalog: getServiceCatalog(builder),
    }),
  })
  .enhanceEndpoints({
    addTagTypes: [SERVICE_CATALOG_TAGS],
  });

export const { useGetServiceCatalogQuery } = serviceCatalogApi;
